<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-input
          v-model="getUserVisitorTypeList_data.vtName"
          placeholder="请输入拜访类型名"
          clearable
          size='small'
          style="max-width:380px;"/>
        <el-button
          v-click.getUserVisitorTypeList
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>
      </el-col>
      <el-col :span="6" >
        <el-button
          v-if='addUserVisitorType'
          @click=" $form('addUserVisitorType') "
          size='small'
          type="primary"
          style="float:right"
          icon='el-icon-circle-plus'
        >添加拜访类型
        </el-button>
      </el-col>
    </el-row>

    <mytable
      :tableColums='tableColums_getUserVisitorTypeList'
      api='getUserVisitorTypeList'
      updateapi='updateUserVisitorType'
      :height="H-165" >
    </mytable> 

    <myform
      :viewobj='{
        addUserVisitorType:    [ "新增拜访类型信息", "el-icon-circle-plus" ],
        updateUserVisitorType: [ "修改拜访类型信息", "el-icon-edit-outline"],
        $succeed$: getUserVisitorTypeList
      }'
      @close='$form("addUserVisitorType","reset")' >
      <!-- <hide slot='vtId' /> -->
    </myform>
  </div>
</template>

<script>
export default {
  data() {
    return {
      vtId: null,

      tableColums_getUserVisitorTypeList: {
        $selection: false,

        vtName: '拜访名称',

        vtType: '拜访类型分类',

        vtOrder: '排序',

        // ycDelete: ['状态',,'@v-if: 1:正常 🔍#(--Themecolor),  3:弃用 🖊#warn, 2:已删除 ❌#danger+'],

        $operation: [
          '操作', 200,
          this.updateUserVisitorType && `@text: 编辑#success
           @click: $form("updateUserVisitorType",$row)
          `,
          this.deleteUserVisitorType && `@text: 删除#danger
           @click: _confirm('确定要删除该拜访类型吗?')
                   .trigger('deleteUserVisitorType',{vtId:$row.vtId})
                   .trigger('getUserVisitorTypeList')
          `,
        ],

      },

    };
  },

  watch: {
    
  },

  methods: {},

  created() {
    this.getUserVisitorTypeList();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/help/VisitRecordType.vue